define('shared/util/validate/validators/phoneRange',['shared/lib/validate', 'shared/page/market', 'shared/lib/RSVP'],
    function (validate, getMarket, RSVP) {
        'use strict';

        var KEY = 'phoneRange';
        var REASON = 'phone number is not in a valid range';

        function validator(value, options, key, attributes) {
            return getMarket().then(function (pageMarket) {
                if (!value) {
                    return RSVP.reject('Empty phone number');
                }

                return RSVP.resolve();
            });
        }

        validate.validators[KEY] = validator;
        validator.KEY = KEY;

        return validator;

    });
